var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('debt-action-balances',{staticClass:"pb-4",attrs:{"debt":_vm.debt}}),_vm._v(" "),_c('debt-action-payments',{attrs:{"debt":_vm.debt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }